import request from "./requests";

export const TRAIT_CATEGORIES = [
  { key: "lifestyle", label: "Lifestyle" },
  { key: "interests", label: "Interests" },
  { key: "values", label: "Values" },
  { key: "personality", label: "Personality" },
  { key: "intimacy", label: "Intimacy" },
  { key: "relationships", label: "Relationships" },
  { key: "communication", label: "Communication" },
  { key: "boundaries", label: "Boundaries" },
  { key: "ambitions", label: "Ambitions" },
  { key: "identity", label: "Identity" },
];

export const getMatchmakerProfile = async () => request("matchprofile/profile");

export const startMatchmakerProfile = async () =>
  request("matchprofile/start", "post", {});

export const getTraits = async () => request("matchprofile/traits");

export const deleteTrait = async ({ id, promptType }) =>
  request("matchprofile/traits/delete", "post", { id, promptType });

export const submitTranscripts = async ({ aboutMe, lookingFor }) =>
  request("matchprofile/transcripts", "post", { aboutMe, lookingFor });
